"use client";

import { c as _c } from "react/compiler-runtime";
import { useFeatureValue } from "@growthbook/growthbook-react";
import TrackingBase from "./TrackingBase";

/**
 * Tracking for Pages Router (client-side feature flag check)
 * Uses GrowthBookProvider context to check feature flag
 * Used in: src/hocs/page.tsx
 */
export default function TrackingPagesRouter() {
  const $ = _c(2);
  const isPiwikEnabled = useFeatureValue("piwik_tracking", true);
  let t0;
  if ($[0] !== isPiwikEnabled) {
    t0 = <TrackingBase isPiwikEnabled={isPiwikEnabled} />;
    $[0] = isPiwikEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}